import React from "react";
import "./index.scss";

const AnimatedLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="route-loader-overlay" role="status" aria-live="polite">
      <div className="route-loader-content">
        <img
          data-loader
          src="/panda_logo.jpg"
          alt="Panda On Wheels"
          className="route-loader-logo"
        />
        <div className="route-loader-spinner" aria-hidden="true" />
        <p className="route-loader-text">Panda is on the way…</p>
      </div>
    </div>
  );
};

export default AnimatedLoader;
